import { useState } from 'react';

import { Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { IconEmail } from '@/components';
import { type CandidateBasicDto } from '@/services/api';

import { InviteCandidatesConfirmationModal } from './InviteCandidatesConfirmationModal';

interface EmailCandidatesProps {
  interviewId?: string;
  selectedCandidates: Array<CandidateBasicDto>;
  totalCandidates: number;
  onClearSelection: () => void;
  isDisabled?: boolean;
  isDropDownButton?: boolean;
}

export const EmailCandidates: React.FC<EmailCandidatesProps> = ({
  interviewId,
  selectedCandidates,
  totalCandidates,
  onClearSelection,
  isDisabled,
  isDropDownButton,
}) => {
  const { t } = useTranslation(['candidate']);
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        leftIcon={<IconEmail fontSize={isDropDownButton ? 'xl' : 16} />}
        isDisabled={isDisabled ?? totalCandidates === 0}
        size="md"
        display="flex"
        justifyContent="start"
        alignItems="center"
        variant={isDropDownButton ? 'unstyled' : 'solid'}
        px={3}
        w={isDropDownButton ? 'full' : 'auto'}
        textAlign="left"
        columnGap={1}
        _hover={{ bg: 'gray.50' }}
        borderRadius={isDropDownButton ? 0 : 'xl'}
      >
        {t('inviteNewCandidate.emailToCandidates', {
          count: selectedCandidates.length,
        })}
      </Button>
      <InviteCandidatesConfirmationModal
        isOpen={isModalOpen}
        onClose={() => {
          onClearSelection();
          setIsModalOpen(false);
        }}
        interviewId={interviewId}
        selectedCandidates={selectedCandidates}
      />
    </>
  );
};
